export const TRANSACTION_GOS_FETCH = 'TRANSACTION_GOS_FETCH';
export const TRANSACTION_GOS_RECALL = 'TRANSACTION_GOS_RECALL';
export const TRANSACTION_GOS_GENERATE_GO = 'TRANSACTION_GOS_GENERATE_GO';
